import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IPointOfSaleActive,
  POINT_OF_SALE_ACTIVE_TTL_ES
} from '../../point-of-sale-active.interface';
import { PointOfSaleActiveService } from '../../point-of-sale-active.service';

@Component({
  selector: 'pg-point-of-sale-active-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class PointOfSaleActiveSelectComponent extends SelectTemplate {
  constructor(private serviceBase: PointOfSaleActiveService) {
    super(POINT_OF_SALE_ACTIVE_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: POINT_OF_SALE_ACTIVE_TTL_ES,
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Código', field: 'code' },
        { header: 'Serie de Comprobante', field: 'seriesOfReceipts' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IPointOfSaleActive[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
